import { render, staticRenderFns } from "./Emergency_Configuration.vue?vue&type=template&id=5fe3e440&scoped=true"
import script from "./Emergency_Configuration.vue?vue&type=script&lang=js"
export * from "./Emergency_Configuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe3e440",
  null
  
)

export default component.exports